import { render, staticRenderFns } from "./Dashboard1.vue?vue&type=template&id=797f4b9e"
import script from "./Dashboard1.vue?vue&type=script&lang=js"
export * from "./Dashboard1.vue?vue&type=script&lang=js"
import style0 from "./Dashboard1.vue?vue&type=style&index=0&id=797f4b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports